import React from "react";

const Gallery = () => {
  return (
    <div className="container">
      <h2 className="entry-title mt-3 mb-3 text-center">Album Gallery</h2>
      <div className="mt-2 mb-3 text-center">No gallery images available</div>
    </div>
  );
};

export default Gallery;
